import { useState } from "react";
import { Images } from "lucide-react";
import { mediaUrl, waLink } from "@/lib/api";
import { Reveal, SectionHead } from "./Reveal";
import { Lightbox } from "./Lightbox";
import { WhatsAppIcon } from "./icons";

const RoomCard = ({ room, s, i, onGallery }) => {
  const cover = room.cover || room.photos?.[0];
  const msg = (s.wa_msg_room || s.wa_msg_accommodations).replace("{acomodacao}", room.name);
  return (
    <Reveal delay={(i % 2) * 0.12} className={i % 2 === 1 ? "md:mt-24" : ""}>
      <article data-testid={`accommodation-card-${i}`} className="group">
        <button onClick={onGallery} disabled={!room.photos?.length} className="relative block w-full aspect-[4/5] overflow-hidden bg-[#141418]" aria-label={`Ver fotos de ${room.name}`} data-testid={`accommodation-gallery-button-${i}`}>
          {cover && <img src={mediaUrl(cover)} alt={room.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-[1.04]" />}
          <span className="absolute inset-0 bg-gradient-to-t from-[#08080A]/80 via-transparent to-transparent" />
          {room.photos?.length > 0 && (
            <span className="absolute bottom-5 left-5 inline-flex items-center gap-2 text-[0.65rem] uppercase tracking-[0.25em] text-white/85">
              <Images className="w-4 h-4" strokeWidth={1.2} /> {room.photos.length} {room.photos.length === 1 ? "foto" : "fotos"}
            </span>
          )}
        </button>
        <div className="pt-8">
          <h3 className="font-display text-3xl lg:text-4xl text-white" data-testid={`accommodation-name-${i}`}>{room.name}</h3>
          {room.description && <p className="mt-4 text-sm sm:text-base text-[#A1A1AA] leading-relaxed whitespace-pre-line">{room.description}</p>}
          {room.amenities?.length > 0 && (
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2" data-testid={`accommodation-amenities-${i}`}>
              {room.amenities.map((a) => (
                <li key={a} className="text-xs uppercase tracking-[0.18em] text-[#CBD5E1] flex items-center gap-2">
                  <span className="h-1 w-1 rotate-45 bg-[#C5A059]" /> {a}
                </li>
              ))}
            </ul>
          )}
          <a href={waLink(s.whatsapp_number, msg)} target="_blank" rel="noopener noreferrer" className="btn-lux mt-8" data-testid={`accommodation-whatsapp-button-${i}`}>
            <WhatsAppIcon className="w-4 h-4" /> Consultar disponibilidade
          </a>
        </div>
      </article>
    </Reveal>
  );
};

export const Accommodations = ({ s, rooms }) => {
  const [box, setBox] = useState({ images: [], index: null });
  return (
    <section id="acomodacoes" data-testid="accommodations-section" className="bg-[#08080A] py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead label={s.acc_label} title={s.acc_title} subtitle={s.acc_subtitle} testid="accommodations-title" />
        {rooms.length === 0 ? (
          <Reveal className="border border-white/10 p-10 sm:p-14 max-w-3xl" >
            <p className="font-display text-2xl sm:text-3xl text-white" data-testid="accommodations-empty">Informações das acomodações em breve.</p>
            <p className="mt-4 text-[#A1A1AA] text-sm sm:text-base">Fale com a nossa equipe para conhecer as opções disponíveis.</p>
            <a href={waLink(s.whatsapp_number, s.wa_msg_accommodations)} target="_blank" rel="noopener noreferrer" className="btn-lux mt-8" data-testid="accommodations-empty-whatsapp-button">
              <WhatsAppIcon className="w-4 h-4" /> Conhecer as acomodações
            </a>
          </Reveal>
        ) : (
          <div className="grid md:grid-cols-2 gap-x-10 lg:gap-x-16 gap-y-20">
            {rooms.map((r, i) => (
              <RoomCard key={r.id} room={r} s={s} i={i} onGallery={() => setBox({ images: r.photos.map((u) => ({ url: u, caption: r.name })), index: 0 })} />
            ))}
          </div>
        )}
      </div>
      <Lightbox images={box.images} index={box.index} onClose={() => setBox((b) => ({ ...b, index: null }))} onIndex={(index) => setBox((b) => ({ ...b, index }))} />
    </section>
  );
};
